import { GroupedMap, ListenableEvent, Log } from "../utils";
export class AppDocument {
    /**
     * Can be used to store application specific data inside the document.
     */
    get appData() {
        return (this.mAppData);
    }
    get app() {
        return (this.mApp);
    }
    constructor(pApp) {
        this.eventBeforeClear = new ListenableEvent(this);
        this.eventAfterClear = new ListenableEvent(this);
        this.eventBeforeLoad = new ListenableEvent(this);
        /** Triggered after the document was loaded. If the event parameter is true, the loading was aborted or failed. */
        this.eventAfterLoad = new ListenableEvent(this);
        this.eventBeforeSave = new ListenableEvent(this);
        /** Triggered after the document was saved. If the event parameter is true, the saving was aborted or failed. */
        this.eventAfterSave = new ListenableEvent(this);
        this.mApp = pApp;
        this.mAppData = new GroupedMap();
    }
    clear() {
        try {
            this.eventBeforeClear.trigger();
            this.mApp.model.beginModification();
            this.mApp.commands.clearHistory();
            this.mApp.viewer.resetView();
            this.mApp.model.clear();
            this.mAppData.clear();
            //clear modules
            for (const tModule of this.mApp.modules) {
                try {
                    tModule.clearDocumentData();
                }
                catch (pError) {
                    Log.error("failed to clear module " + tModule.moduleId, pError);
                }
            }
        }
        finally {
            this.mApp.model.endModification();
            this.eventAfterClear.trigger();
        }
    }
    //// internal //////////////////////////////////////////////////////////////////////////////////
    /** @internal */
    _setAppData(pData) {
        this.mAppData = pData;
    }
}
